module.exports = __webpack_public_path__ + "img/type3_bg1.3cc8e9c3.png";